import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { UiAppNoDataModule } from '../../_ui/ui-app-no-data/ui-app-no-data.module';
import { UiControlSchoolsComponent } from './ui-control-schools.component';
import { UiTooltipModule } from '../../_ui/ui-tooltip/ui-tooltip.module';
import { PipesModule } from '../../app.pipes.module';
import { AppTranslocoModule } from '../../app.transloco.module';
import { UiPaginationModule } from '../../_ui/ui-pagination/ui-pagination.module';

@NgModule({
  declarations: [UiControlSchoolsComponent],
  exports: [UiControlSchoolsComponent],
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: '',
        component: UiControlSchoolsComponent,
        children: [
          {
            path: ':license',
            component: UiControlSchoolsComponent,
          },
        ],
      },
    ]),
    UiAppNoDataModule,
    UiTooltipModule,
    PipesModule,
    AppTranslocoModule,
    UiPaginationModule,
  ],
})
export class UiControlSchoolsModule {}
